import { render, staticRenderFns } from "./apartment-location-standard-finish.vue?vue&type=template&id=0cf05694&scoped=true&"
import script from "./apartment-location-standard-finish.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-standard-finish.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-standard-finish.scss?vue&type=style&index=0&id=0cf05694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf05694",
  null
  
)

export default component.exports